import React from 'react';

const NotFoundPage = () => {
    return (
        <div className="container-fluid d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
            <div className="text-center p-4 border border-danger rounded shadow">
                <h1 className="text-danger">404 - Page Not Found</h1>
                {/* <p className="lead">You do not have permission to view this page.</p> */}
            </div>
        </div>
    );
};

export default NotFoundPage;
